import type { Word } from '@/models/word';
import { http } from '@/services/config';

const getTodaysWord = async () => {
    const result =  await http.get('/api/word');
    return result;
}

const saveWordToDB = async (word: Word) => {
    const result =  await http.post('/api/saveWord', word);
    return result.data;
}

export {
    getTodaysWord,
    saveWordToDB
};
